


































import { Component, Vue, Prop } from "vue-property-decorator";
import { Mutation } from "vuex-class";

@Component
class AssetItem extends Vue {
  @Mutation("wallet/mixin/ADD_ADDED_ASSET") addAddedAsset;

  @Mutation("wallet/mixin/REMOVE_ADDED_ASSET") removeAddedAsset;

  @Prop() asset;

  @Prop() isFilter;

  loading = false;

  handleAddedChange(val) {
    if (val) {
      this.requestAddAsset(this.asset.asset_id);
    } else {
      this.removeAddedAsset(this.asset);
    }
  }

  async requestAddAsset(id) {
    this.loading = true;
    try {
      const asset = await this.$api.wallet.mixin.getAsset(id);
      this.addAddedAsset(asset);
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default AssetItem;
